export const MuiSelect = {
    styleOverrides: {
        select: {
            height: '1.5rem',
        },
        icon: ({ theme }) => ({
            color: theme.palette.text.disabled,
        }),
    },
};
